import axios from 'axios'
import { history } from '../store'
import { isTokenValid } from '../utils/index'

const requestAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 30000,
  responseType: 'json',
  withCredentials: true
})

requestAPI.interceptors.request.use(async (config) => {
    const isValid = await isTokenValid()
  
    if (!isValid) {
      history.push('/login')
    }
    const authToken = JSON.parse(localStorage.getItem('authToken'))
    
    return {
      ...config,
      headers: {
        Authorization: `Bearer ${authToken ? authToken.token : ''}`
      }
    }
})

export default requestAPI
